export default __webpack_public_path__ + "static/media/Behance.5ad82d4c.svg";